import axios from "axios";

const requestAccountCertify = parameter => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/popbill/account?accountNumber=${parameter.accountNumber}&bankCode=${parameter.bankCode}`
  );
};

export { requestAccountCertify };
